"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeliveryAnyCityColor = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DeliveryAnyCityColor = function DeliveryAnyCityColor(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#DeliveryAnyCityColor_svg__DeliveryAnyCityColor_svg__clip0_19281_92436)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F4F9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.44 37.412a4.118 4.118 0 00-3.879 2.733l-2.55 7.142a2.47 2.47 0 002.326 3.301h23.326a2.47 2.47 0 002.327-3.301l-2.551-7.142a4.118 4.118 0 00-3.878-2.733H24.439z",
    fill: "#97BA1E",
    stroke: "#547012",
    strokeWidth: 1.647
  }), /*#__PURE__*/React.createElement("mask", {
    id: "DeliveryAnyCityColor_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 19.544,
    y: 13,
    width: 25,
    height: 32,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.544 13h25v32h-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8 30.6c-2.831 0-5.128-2.328-5.128-5.2 0-2.87 2.297-5.2 5.128-5.2 2.832 0 5.128 2.33 5.128 5.2 0 2.872-2.296 5.2-5.128 5.2zm10.221-5.9c-.357-5.417-4.79-9.7-10.22-9.7-5.431 0-9.865 4.283-10.222 9.7a6.905 6.905 0 00-.035.7c0 6.126 6.325 13.321 9.04 16.128.67.69 1.763.69 2.431 0 2.717-2.807 9.041-10.002 9.041-16.127 0-.26-.014-.49-.035-.702z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8 30.6c-2.831 0-5.128-2.328-5.128-5.2 0-2.87 2.297-5.2 5.128-5.2 2.832 0 5.128 2.33 5.128 5.2 0 2.872-2.296 5.2-5.128 5.2zm10.221-5.9c-.357-5.417-4.79-9.7-10.22-9.7-5.431 0-9.865 4.283-10.222 9.7a6.905 6.905 0 00-.035.7c0 6.126 6.325 13.321 9.04 16.128.67.69 1.763.69 2.431 0 2.717-2.807 9.041-10.002 9.041-16.127 0-.26-.014-.49-.035-.702z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.579 24.7l1.99.2.003-.034.003-.035-1.996-.132zm9.006 16.828l1.437-1.391-1.437 1.39zm2.43 0l-1.437-1.391 1.437 1.39zM31.8 28.6c-1.7 0-3.128-1.407-3.128-3.2h-4c0 3.95 3.166 7.2 7.128 7.2v-4zm-3.128-3.2c0-1.794 1.427-3.2 3.128-3.2v-4c-3.962 0-7.128 3.25-7.128 7.2h4zm3.128-3.2c1.7 0 3.128 1.406 3.128 3.2h4c0-3.95-3.165-7.2-7.128-7.2v4zm3.128 3.2c0 1.793-1.427 3.2-3.128 3.2v4c3.963 0 7.128-3.25 7.128-7.2h-4zm9.089-.833C43.592 18.135 38.319 13 31.8 13v4c4.343 0 7.935 3.431 8.226 7.831l3.99-.263zM31.8 13c-6.518 0-11.792 5.135-12.217 11.568l3.992.263c.29-4.4 3.882-7.831 8.225-7.831v-4zM19.59 24.498a8.912 8.912 0 00-.046.903h4c0-.187.01-.35.025-.5l-3.98-.403zm-.046.903c0 3.668 1.856 7.41 3.832 10.408 2.016 3.06 4.37 5.662 5.772 7.11l2.874-2.782c-1.315-1.36-3.481-3.759-5.306-6.529-1.866-2.832-3.172-5.75-3.172-8.207h-4zm9.603 17.517a3.685 3.685 0 005.306 0l-2.875-2.781a.316.316 0 01.444 0l-2.875 2.781zm5.306 0c1.4-1.447 3.755-4.048 5.771-7.11 1.976-2.997 3.832-6.739 3.832-10.407h-4c0 2.456-1.306 5.375-3.172 8.207-1.825 2.77-3.99 5.17-5.306 6.529l2.875 2.782zm9.603-17.517c0-.332-.017-.63-.045-.903l-3.98.402c.015.15.025.314.025.5h4z",
    fill: "#547012",
    mask: "url(#DeliveryAnyCityColor_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 47.5h14.078a4 4 0 003.123-1.501L37.299 44a4 4 0 013.123-1.501H44",
    stroke: "#547012",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "DeliveryAnyCityColor_svg__DeliveryAnyCityColor_svg__clip0_19281_92436"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  }))));
};

exports.DeliveryAnyCityColor = DeliveryAnyCityColor;
var _default = DeliveryAnyCityColor;
exports.default = _default;